{
    "common": {
        "skipLink": {
            "skipTo": "Preskočiť na",
            "labels": {
                "header": "Hlavička",
                "main": "Hlavný obsah",
                "footer": "Päta",
                "productFacets": "Filtrovanie produktov",
                "productList": "Zoznam produktov"
            }
        },
        "common": {
            "cancel": "Zrušiť",
            "back": "Späť",
            "reset": "Resetovať",
            "search": "Hľadať",
            "remove": "Odstrániť",
            "home": "Domov",
            "contacts": {
                "openingHours": "(Pon-Pia 8:00 - 15:30)",
                "sikob2bspacz": {
                    "phone": "+420 222 300 666",
                    "email": "velkoobchod@siko.cz",
                    "helplineAvailibility": "(Po-Pi 8:00 - 15:30)"
                },
                "sikob2bspask": {
                    "phone": "+421 222 300 666",
                    "email": "velkoobchod@siko.sk",
                    "helplineAvailibility": "(Po-Pi 8:00 - 15:30)"
                },
                "sikob2bspaeu": {
                    "phone": "+420 222 300 666",
                    "email": "info@b2b.siko.eu",
                    "helplineAvailibility": "(Po-Pi 8:00 - 15:30)"
                }
            }
        },
        "formErrors": {
            "labeled": {
              "email": "Neplatný email",
              "sikoWrongValueDiscount": "Hodnota zľavy mimo povolený rozsah.",
                "sikoInvalidTotalPrice": "Objednávku nebolo možné odoslať z dôvodu nízkej hodnoty.",
                "sikoTermsAndConditions": "Súhlas s obchodnými podmienkami je povinný.",
                "sikoPreferredPickupDateWeekendDisable": "Odber cez víkend nie je možný",
                "sikoPreferredPickupDateHigherThanMax": "Zadajte dátum max. 2 mesiace v budúcnosti.",
                "sikoPreferredPickupDateLowerThanToday": "Zadaný dátum nesmie byť nižší ako aktuálny dátum.",
                "sikoRequiredDate": "Nesprávny alebo chýbajúci dátum.",
                "sikoCheckoutNote": "Prekročili ste povolenú dĺžku 255 znakov",
                "sikoPoNumber": "Prekročili ste povolenú dĺžku 35 znakov",
                "required": "Povinné",
                "pattern": "Zadajte správny formát",
                "cxInvalidPassword": "Heslo nespĺňa minimálne požiadavky. (Najmenej 8 znakov, vrátane 1 písmena a 1 čísla)",
                "cxInvalidOldPassword": "Zadajte svoje aktuálne heslo",
                "cxPasswordsMustMatch": "Heslá sa musia zhodovať",
                "cxInvalidEmail": "Toto nie je platný formát e-mailu",
                "cxEmailsMustMatch": "E-mailové adresy sa musia zhodovať",
                "maxlength": "Zadaný údaj presahuje maximálnu dĺžku ",
                "sikoPhoneFormat": "Zadajte správny formát pre telefón",
                "sikoVat": "Zadajte správny formát pre DIČ",
                "sikoTaxId": "Zadajte správny formát pre IČ DPH",
                "sikoPostCode": "Zadajte správný formát pre PSČ",
                "sikoPassword": "Neplatný formát hesla (Zadajte najmenej 8 znakov, vrátane 1 písmena a 1 čísla)",
                "sikoFullNameLength": "Položky (Meno, Priezvisko) presahujú maximálnu dĺžku (40)",
                "sikoCompanyName": "Zadaný údaj presahuje maximálnu dĺžku (40)",
                "sikoPin": "Zadajte 6 miestny číselný kód PIN, ktorý Vám bol doručený prostredníctvom e-mailu alebo SMS správy",
                "matDatepickerParse": "Zadajte platný dátum vo formáte dd.mm.rrrr",
                "matDatepickerFilter": "Zadajte platný dátum vo formáte DD.MM.RRRR",
                "matDatepickerMin": "Zadajte platný rozsah dátum.",
                "sikoInvalidCode": "Zadaný kód kupónu nie je platný.",
                "sikoPositiveNumber": "Zadajte kladné číslo",
                "emailNotAllowed": "Neplatné užívateľské meno",
                "file": {
                    "notParsable": "Súbor nie je možné načítať",
                    "tooManyEntries": "Počet položiek je väčší ako {{ maxEntries }}",
                    "empty": "Súbor nesmie byť prázdny",
                    "invalidExtension": "Nepodporovaný formát súboru",
                    "tooLarge": "Veľkosť súboru nesmie presiahnuť {{ maxSize }} MB"
                }
            }
        },
        "customLoginPage": {
           "badRequest": {
              "bad_credentials": "<strong>Neplatné prihlasovacie údaje. Prosím, prihláste sa znova.</strong><br><br>Ak ste si istí, že zadávate správne heslo, môže byť potrebné ho z dôvodu aktualizácie systému obnoviť pomocou možnosti <strong>„Zabudnuté heslo“</strong>.",
              "account_disabled": "Používateľ je deaktivovaný. Prosím, kontaktujte administráciu.",
              "unknown_error": "Vyskytla sa neznáma chyba. Prosím, skúste to neskôr.",
              "missing_id": "Prihlásenie nebolo úspešné. Prosím, počkajte na potvrdzovací e-mail.",
              "missing_store": "Prihlásenie nebolo úspešné. Prosím, kontaktujte zákaznícke centrum pre vyriešenie.",
              "wrong_basestore": "Prihlásenie nebolo úspešné. Prosím, skontrolujte si správnosť zadanej URL adresy podľa Vašej registrácie."
           }
        },
        "httpHandlers": {
            "SikoCartPaymentMinValueError": "Príliš nízka hodnota objednávky. Zvoľte prosím iný spôsob platby.",
            "maintenanceError": "Táto služba je dočasne nedostupná z dôvodu údržby.",
            "loginRequire": "Pred nárokovaním kupónu sa prosím prihláste.",
            "userUidNotFound": "Nie je možné nájsť užívateľa s UID: {{ uid }}",
            "cartNotFound": "Košík sa nenašiel. Obnovte stránku, prosím",
            "invalidCodeProvided": "Zadaný neplatný kód.",
            "badRequestOldPasswordIncorrect": "Staré heslo je nesprávne.",
            "badRequest": {
                "bad_credentials": "Nesprávne prihlasovacie údaje. Prosím skúste to znova.",
                "password_expired": "{{ errorMessage }}. Prosím zmeňte svoje heslo.",
                "user_is_disabled": "Používateľ je zakázaný. Kontaktujte prosím administratívu."
            },
            "sessionExpired": "Platnosť vašej relácie vypršala. Prihláste sa prosím znova.",
            "authenticationErrors": {
                "badRequest": "Prihlásenie nebolo úspešné. Prosím skúste to znova.",
                "wrongUserModel": "Do ASM sa môže prihlásiť iba zamestnanec.",
                "asmAgentMissingRoles": "Agentovi ASM chýbajú potrebné oprávnenia"
            },
            "forbidden": "Na vykonanie tejto akcie nemáte oprávnenie. Ak si myslíte, že ide o chybu, kontaktujte svojho správcu.",
            "timeout": "Nie je možné zobraziť obsah pre zadané obdobie. Skúste zmenšiť vyhľadávané obdobie.",
            "badGateway": "Došlo k chybe serveru. Prosím skúste to znova neskôr.",
            "gatewayTimeout": "Server neodpovedal, skúste to znova neskôr.",
            "validationErrors": {
                "missing": {
                    "deliveryAddressStreetNumber": "Neplatné číslo ulice doručenia",
                    "deliveryAddress": {
                        "countryIso": "Neplatný kód krajiny spoločnosti",
                        "postcode": "Neplatné PSČ spoločnosti"
                    },
                    "email": "Neplatný email",
                    "phonePrefix": "Nesprávna telefónna predvoľba"
                },
                "invalid": {
                    "password": "Zadané heslo nie je platné.",
                    "companyId": "Neplatné ID spoločnosti",
                    "companyVatId": "Neplatné IČ DPH spoločnosti",
                    "legalFormType": "Neplatný typ právnej formy",
                    "companyName": "Neplatný názov spoločnosti",
                    "companyAddressCity": "Neplatný názov mesta spoločnosti",
                    "companyAddressPostalCode": "Neplatné PSČ spoločnosti",
                    "companyAddressStreet": "Neplatný názov ulice spoločnosti",
                    "companyAddressStreetNumber": "Neplatné číslo ulice spoločnosti",
                    "companyAddressCountryIso": "Neplatný kód krajiny spoločnosti",
                    "deliveryAddressStreetNumber": "Neplatné číslo ulice doručenia",
                    "phone": "Neplatné telefónne číslo",
                    "email": "Neplatný e-mail",
                    "phonePrefix": "Neplatná mobilná predvoľba",
                    "contactPerson": {
                        "firstName": "Neplatné krstné meno",
                        "lastName": "Neplatné priezvisko",
                        "email": "Neplatný e-mail",
                        "pwd": "Nesprávne heslo",
                        "checkPwd": "Nesprávne heslo",
                        "consentForm": {
                            "phone": "Neplatné telefónne číslo"
                        }
                    },
                    "deliveryAddress": {
                        "townCity": "Neplatné mesto doručenia",
                        "line1": "Neplatný názov ulice doručenia",
                        "postcode": "Neplatné PSČ doručenia"
                    },
                    "couponAssignResult": {
                        "ASSIGNED": "Tento zákaznícky kupón ste si už nárokovali.",
                        "INEXISTENCE": "Tento zákaznícky kupón neexistuje.",
                        "INCORRECTPROMOGROUP": "Tento zákaznícky kupón je neplatný."
                    }
                }
            },
            "sikoTicketMaxUploadSize": "Súčet veľkosti súborov môže byť maximálne {{ maxSize }} MB",
            "sikoTicketMaxCountOfFiles": "Maximálny počet obrázkov je 10",
            "notFound": {
                "product": "Produkt sa nenašiel",
                "category": "Kategória produktov sa nenašla"
            },
            "cart": {
                "noRestoredEntries": "Žiadne položky košíka neboli obnovené.",
                "reloadCartRequired": "Nastala zmena v košíku. Obnovte prosím stránku.",
                "changePartialDeliveryFailed": "Nastavenie čiastočného dodania nebolo úspešné"
            },
            "product": {
                "reviewPostForbidden": "Recenziu je možné napísať iba k produktom, ktoré ste u nás zakúpili."
            }
        },
        "navigation": {
        "categoryNavLabel": "Ponuka kategórií",
        "footerNavLabel": "Odkazy v päte stránky",
        "goTo": "Prejsť na {{location}}",
        "navigateTo": "Navigovať k {{nav}}",
        "scrollToTop": "Vráťte sa na začiatok stránky.",
        "linkItemInList": "{{title}}. {{position}} z {{listLength}}",
        "menuButonTitle": "{{title}} Menu"
      },
        "miniCart": {
          "item": "{{count}} položka momentálne vo vašom košíku",
          "item_other": "{{count}} položiek momentálne vo vašom košíku",
          "total": "{{total}}",
          "count": "{{count}}"
        },
        "pageMetaResolver": {
            "category": {
                "title": "{{count}} výsledok pre {{query}}",
                "title_other": "Počet výsledkov pre {{query}}: {{count}}"
            },
            "checkout": {
                "title": "Pokladňa"
            },
            "search": {
                "title": "{{count}} výsledok pre „{{query}}“",
                "title_other": "Počet výsledkov pre „{{query}}“: {{count}}",
                "findProductTitle": "{{count}} výsledok pre kupón „{{coupon}}“",
                "findProductTitle_other": "Počet výsledkov pre kupón „{{coupon}}“: {{count}}",
                "default_title": "Všetky produkty"
            },
            "product": {
                "description": "{{description}}",
                "heading": "{{heading}}",
                "title": "{{title}}"
            }
        }
    },
    "organization": {
        "orgUnit": {
            "header": "Obchodné jednotky",
            "uid": "ID obchodnej jednotky",
            "name": "Názov obchodnej jednotky",
            "assignedPos": "Predajná kancelária",
            "assignedWorker": "Zodpovedný pracovník SIKO",
            "state": "Stav"
        },
        "orgUser": {
            "active": "Status",
            "name": "Používateľ",
            "unit": "Obchodná jednotka",
            "sort": {
                "byName": "Mena",
                "byUnit": "Jednotky"
            }
        },
        "organization": {
            "enabled": "Aktívny",
            "disabled": "Zakázaný",
            "httpHandlers": {
                "conflict": {
                    "user": "Používateľ s e-mailom {{code}} už existuje."
                }
            },
            "notification": {
                "noSufficientPermissions": "Nemáte dostatočné povolenia na prístup k tejto stránke"
            }
        }
    },
    "checkout": {
        "checkout": {
            "invalid": {
                "accountType": "Na uskutočnenie nákupu musíte mať rolu zákazníka."
            }
        }
    },
    "checkoutB2B": {
        "checkoutB2B": {
            "invalid": {
                "accountType": "Na uskutočnenie nákupu musíte mať rolu zákazníka."
            }
        }
    },
    "configuration": {
        "configuration": {
            "configure": "Konfigurovať"
        }
    },
    "product": {
        "itemCounter": {
            "removeOne": "Odobrať jeden",
            "addOneMore": "Pridať jeden",
            "quantity": "Množstvo"
        },
        "product": {
            "productPageTitle": "{{title}} | SIKO B2B"
        },
        "addToCart": {
            "addToCart": "Pridať do košíka"
        },
        "productReview": {
            "thankYouForReview": "Ďakujeme za Vašu recenziu."
        },
        "TabPanelContainer": {
            "tabs": {
                "ProductDetailsTabComponent": "Detail produktu",
                "ProductReviewsTabComponent": "Hodnotenia",
                "ProductDocumentsTabComponent": "Dokumenty"
            }
        }
    },
    "myAccount": {
        "updateProfileForm": {
            "customerId": "E-mailová adresa",
            "firstName": {
                "label": "Meno"
            },
            "lastName": {
                "label": "Priezvisko"
            },
            "profileUpdateSuccess": "Osobné údaje boli úspešne aktualizované"
        },
        "myCoupons": {
            "claimCustomerCoupon": "Úspešne ste si nárokovali tento kupón."
        }
    },
    "userAccount": {
        "loginForm": {
            "forgotPassword": "Zabudli ste svoje heslo?",
            "signIn": "Chcem sa prihlásiť",
            "register": "Registrovať sa",
            "dontHaveAccount": "Nemáte účet?",
            "emailAddress": {
                "label": "E-mail",
                "placeholder": "E-mail"
            },
            "password": {
                "label": "Heslo",
                "placeholder": "Heslo"
            },
            "wrongEmailFormat": "Toto nie je platný formát e-mailu.",
            "logIn": "Prihlásiť sa"
        },
        "miniLogin": {
            "userGreeting": "Dobrý deň, {{name}}",
            "signInRegister": "Prihlásiť sa / Registrovať",
            "signIn": "Prihlásiť sa",
            "myAccount": "Môj účet"
        }
    },
    "productListingPage": {
        "productListingPage": {
            "plpPageTitle": "{{title}} | SIKO B2B",
            "searchResultPageTitle": "Vyhľadávanie {{query}} | SIKO B2B"
        }
    },
    "storeFinder": {
        "storeFinder": {
            "noStoresFound": "Žiadna predajňa nebola nájdená...",
            "geolocationNotEnabled": "Nemožno nájsť obchody v okolí. Súhlas s geolokáciou nebol udelený"
        }
    },
    "address": {
        "addressForm": {
            "title": "Oslovenie",
            "defaultTitle": "Titul",
            "companyName": "Meno firmy (voliteľné)",
            "firstName": {
                "label": "Meno",
                "placeholder": "Meno"
            },
            "lastName": {
                "label": "Priezvisko",
                "placeholder": "Priezvisko"
            },
            "address1": "Ulica",
            "address2": "Popisné číslo",
            "country": "Krajina",
            "city": {
                "label": "Mesto",
                "placeholder": "Mesto"
            },
            "state": "Okres",
            "zipCode": {
                "label": "PSČ",
                "placeholder": "PSČ"
            },
            "phoneNumber": {
                "label": "Telefónne číslo",
                "placeholder": "(555) 555 - 0123"
            },
            "email": {
                "label": "E-mail"
            }
        }
    },
    "importExport": {
        "exportEntries": {
            "columnNames": {
                "name": "Názov",
                "code": "Kód",
                "package": "Merná jednotka",
                "retailPrice": "MO cena s DPH",
                "discount": "Zľava zo SIKO ceny",
                "customerPrice": "VO cena bez DPH",
                "totalPrice": "Cena celkom s DPH",
                "unit": "Jednotka",
                "url": "Odkaz",
                "quantity": "Množstvo"
            }
        }
    },
    "cart": {
      "cartItems" : {
        "itemRemoved": "Vybraná položka bola odstránená. Celková suma košíka bola aktualizovaná."
      },
        "validation": {
            "cartEntriesChangeDuringCheckout": "Pri spracovaní objednávky sme zistili problémy s Vašimi položkami. Skontrolujte prosím svoj košík.",
            "cartEntryRemoved": "{{name}} bol vyradený z košíka z dôvodu nedostupnosti.",
            "productOutOfStock": "{{name}} bol odstránený z košíka pre nedostatok zásob.",
            "lowStock": "Množstvo sa znížilo na {{quantity}} z dôvodu nedostatočných zásob.",
            "nonValidTotalPrice": "Z dôvodu nízkej hodnoty košíka nie je možné pokračovať.",
            "couponNotValid": "Kupón nie je validný, preto bol odstránený."
        },
        "voucher": {
            "applyVoucherSuccess": "Kupón {{voucherCode}} bol uplatnený.",
            "removeVoucherSuccess": "Kupón {{voucherCode}} bol odstránený."
        }
    },
    "savedCartList": {
        "savedCartList" : {
            "swapCartNoActiveCart": "Košík \"{{cartName}}\" bol úspešne obnovený.",
            "swapCartWithActiveCart": "Košík \"{{cartName}}\" bol úspešne obnovený. Vaše predchádzajúce položky boli uložené do košíka {{previousCartName}}."
        }
    },
    "savedCartCartPage": {
        "savedCartCartPage": {
            "messages": {
                "cartSaved": "Položky Vášho košíka boli úspešne uložené na neskôr do košíka \"{{cartName}}\""
            }
        }
    },
    "savedCart": {
        "savedCartDialog": {
            "id": "ID",
            "deleteCartSuccess": "Košík bol úspešne zmazaný",
            "editCartSuccess": "Košík bol úspešne uložený"
        }
    },
    "user": {
       "authMessages": {
          "signedOutSuccessfully": "You have been successfully logged out.",
          "unrecoverableError": "Unable to initiate sign-in, please contact your administrator."
       }
    },
    "siko": {
        "siko": {
            "rateLimit": "Z vášho zariadenia evidujeme vyšší počet požiadaviek. Prístup na web SIKO je preto dočasne obmedzený.\nSkúste prosím stránky zavrieť, chvíľu počkať a potom to skúsiť znova.",
            "addedToCartWithReducedAmount": "Množstvo pri položke: {{ product }} bolo znížené z {{ quantity }} {{ unit }} na {{ addedQuantity }} {{ unit }} z dôvodu nedostatočnej zásoby na sklade",
            "totalPriceWithoutTax": "Celkom bez DPH",
            "addToCartAll": "Pridať do košíka všetko",
            "freeGift": "Darček zadarmo",
            "reloadPage": "Obnoviť stránku",
            "datatableOfQuantityRecords_one": "z {{count}} záznamu",
            "datatableOfQuantityRecords_few": "z {{count}} záznamov",
            "datatableOfQuantityRecords_other": "z {{count}} záznamov",
            "correctErrorsBelow": "Prosíme opravte chyby nižšie",
            "buy": "Kúpiť",
            "viewMode": "Rozloženie:",
            "bonusGroup": "VO skupina",
            "importSavedCart": "Importovať uložený košík",
            "yes": "Áno",
            "cancel": "Zrušiť",
            "count": "Množstvo",
            "contactSiko": "Kontakt SIKO",
            "contactHeading": "Kontakt",
            "storeDetail": "Detail predajne",
            "backToStore": "Späť do obchodu",
            "deleteCart": "Zmazať košík",
            "continueInShopping": "Pokračovať v objednávke",
            "delivery": "Doručenie",
            "allowPartialDelivery": "Čiastočné dodanie",
            "withoutVat": "bez DPH",
            "total": "Celkom",
            "sikoPrice": "SIKO cena",
            "superPrice": "Super cena",
            "documents": "Prílohy",
            "withVat": "s DPH",
            "packaging": "Balenie",
            "pricePerPackage": "Cena za balenie",
            "yourPrice": "Vaša cena",
            "quantity": "Počet",
            "priceForEach": "Cena za každého",
            "price": "Cena",
            "priceMO": "MO Cena",
            "item": "Položka",
            "more": "Viac",
            "changePassword": "Zmena hesla",
            "personalData": "Osobné údaje",
            "saveDate": "Uložiť zmeny",
            "removeOrderEntry": "Odobrať",
            "companyId": "IČO",
            "vatId": "DIČ",
            "businessVatId": "IČ DPH",
            "displayDocuments": "Zobraziť dokumenty",
            "orderPoNumber": "Vaše označenie objednávky",
            "datePlaced": "Dátum objednania",
            "order": "Objednávka",
            "sapOrder": "Zákazka",
            "orderPlacedBy": "Objednávka zadaná používateľom",
            "orderStatus": "Stav objednávky",
            "totalPrice": "Celková cena",
            "shippingDetails": "Doručovacie údaje",
            "shippingMethod": "Spôsob dopravy",
            "billingDetails": "Fakturačné údaje",
            "paymentType": "Platobná metóda",
            "repeatPayment": "Opakovať platbu",
            "reorder": "Objednať znovu",
            "sapCodeTitle": "Číslo zákazky",
            "sapQuoteTitle": "Číslo cenovej ponuky",
            "select": "Zvoliť",
            "shipping": "Doprava",
            "savedAmountMessage": "Na objednávke ste ušetrili {{savedAmount}}",
            "orderNote": "Poznámka k objednávke",
            "confirm": "Potvrdiť",
            "discount": "Zľava",
            "searchBoxPlaceHolder": "Skúste napísať napr. vaňa, drez… (alebo zadajte hľadaný výraz…)",
            "searchProduct": "Hľadať produkt",
            "myAccountTitle": "Môj účet",
            "technicalDraw": "Technický nákres",
            "drawing": "Nákres",
            "video": "Video",
            "downloadPdf": "Stiahnuť (.PDF)",
            "emptyFilters": "Nenašli sa žiadne vhodné filtre.",
            "purchasableJustInOtherShopMessage": "Tento produkt je možné zakúpiť len v niektorých predajniach",
            "pickUpInMyStore": "Prevziať na predajni",
            "deliverToAddress": "Doručiť na adresu",
            "pickUpAtAnotherStore": "Prevziať na inej predajni",
            "storeDisponibility": "Dostupnosť na predajni",
            "eShopDisponibility": "Dostupnosť z e-shopu",
            "inStock": "Skladom",
            "outOfStock": "Nedostupné",
            "inCentralStock": "Skladom na centrále",
            "saleEnded": "Predaj bol ukončený",
            "awaiting": "Na ceste",
            "except": "Očakávame:",
            "onOrder": "Na objednávku",
            "days": "dni",
            "fullOffer": "Celá ponuka",
            "ourProductCode": "Náš kód tovaru",
            "ean": "EAN",
            "mark": "Značka",
            "originCountry": "Krajina pôvodu",
            "statisticalNumber": "Štatistické číslo tovaru",
            "category": "Kategórie",
            "topSellingProducts": "Najpredávanejšie",
            "displayNext": "Zobraziť ďalšie",
            "series": "Série",
            "brands": "Značky",
            "product": "Produkt",
            "products": "Produkty",
            "concept": "Koncept",
            "categories": "Kategórie",
            "articles": "Články",
            "stores": "Predajne",
            "showMore": "Zobraziť viac",
            "hide": "Skryť",
            "moreAboutProduct": "Viac o produkte",
            "showDetails": "Zobraziť detail",
            "showAllResults": "Zobraziť všetky výsledky",
            "showFullOffer": "Celá ponuka",
            "continueToRead": "Pokračovať v čítaní",
            "onPredefinedPointOfService": "Na mojej predajni",
            "countOfProducts_one": "{{count}} produkt",
            "countOfProducts_few": "{{count}} produkty",
            "countOfProducts_other": "{{count}} produktov",
            "sortingBy": "Radiť podľa:",
            "filtering": "Filter",
            "sorting": "Zoradenie",
            "proformInvoice": "Proforma faktúra",
            "orderConfirmationMessage": "Potvrdenie zákazky",
            "selectNoItemsFound": "Neboli nájdené žiadne výsledky",
            "notAllowedAction": "Nie je možné vykonať túto akciu",
            "delete": "Zmazať",
            "charactersLeft": "Zostáva znakov : {{count}}",
            "removedCart": "Váš košík bol úspešne vymazaný",
            "or": "alebo",
            "goToCart": "Prejsť do košíka",
            "openDetail": "Otvoriť detail",
            "searchStorePlaceHolder": "Zadajte mesto alebo PSČ",
            "updatePrice": "Aktualizovať cenu",
            "plpLoadMore": "Načítať viac",
            "seenQuantityOfTotal_one": "Videli ste {{quantity}} z {{count}} produktu.",
            "seenQuantityOfTotal_few": "Videli ste {{quantity}} z {{count}} produktov.",
            "seenQuantityOfTotal_other": "Videli ste {{quantity}} z {{count}} produktov.",
            "updateProfileDetails": "Chcem upraviť údaje",
            "contentPageTitle": "{{title}} | SIKO B2B",
            "selectCsvFile": "Vybrať .CSV súbor",
            "importOtherFile": "Vybrať iný súbor",
            "weight": "Hmotnosť",
            "free": "Zadarmo",
            "deleteItem": "Odstrániť položku",
            "checkoutPageTitle": "Platba | SIKO B2B",
            "pickUpInStore": "Odber na predajni",
            "deliveryToAddress": "Doručenie na adresu",
            "addressOfShipment": "SIKO závoz na adresu",
            "cart": "Košík",
            "totalVAT": "DPH celkom",
            "subtotal": "Medzisúčet",
            "orderDiscounts": "Celková zľava",
            "orderTotal": "Celkom k úhrade",
            "notAddedDeliveryRestrictionMessage": "Ospravedlňujeme sa, ale momentálne neumožňujeme doručenie na adresu a prevzatie na predajni v rámci jednej objednávky.",
            "phoneNumberPrefix": "Mobilná predvoľba",
            "backToShop": "Späť do eshopu",
            "insufficientAmount": "Nedostatočná zásoba na predajni {{pointOfService}}",
            "importOrderEntries": "Importovať košík",
            "outOf": "z",
            "predefinedPOS": " (preferovaná)",
            "from": "od",
            "pickupPoints": "Výdajné miesta",
            "unit": {
                "items": "ks"
            },
            "footer": {
                "numberOfStoresInSK": "v SK",
                "numberOfStoresInCZ": "v CZ",
                "needHelp": "Potrebujete pomôcť?",
                "helpAssistanceMessage": "Pridelený zodpovedný pracovník Vám rád pomôže."
            },
            "myAccountSideMenu": {
                "purchases": "Nákupy",
                "account": "Účet"
            },
            "pickupInOtherStoreDialog": {
                "productAvailabilityByStore": "Dostupnosť produktu na predajniach",
                "searchPlaceholder": "Zadajte mesto, obec alebo PSČ:"
            },
            "showcaseDialog": {
                "productShowcaseInStore": "Zoznam predajní, na ktorých je tovar vystavený"
            },
            "address": {
                "id": "IČO",
                "taxId": "DIČ",
                "vatIdCz": "DIČ",
                "vatIdOthers": "IČ DPH",
                "addressForm": {
                    "createAndSet": "Vytvoriť a zvoliť adresu"
                }
            },
            "productLabel": {
                "new": "Novinka",
                "sale": "Výpredaj",
                "hit": "Hit"
            },
            "openingHours": {
                "title": "Otváracie hodiny",
                "currentlyOpen": "Aktuálne otvorené",
                "currentlyClosed": "Aktuálne zatvorené",
                "closed": "Zatvorené",
                "forDay": "Otváracie hodiny pre",
                "openingHoursChanged": "Zmenená otváracia doba"
            },
            "otherStoreDialog": {
                "onOrder": "Prepáčte. Tovar bohužiaľ nemáme na predajni skladom, ale môžete si ho objednať.",
                "inStock": "Máme skladom. Chcete si tovar vyzdvihnúť na vybranej predajni?",
                "orderInStore": "Objednať na predajňu",
                "addToCart": "Vložiť do košíka",
                "searchHeading": "Vyhľadávanie predajní"
            },
            "sellUnits": {
                "MBL": "Malé balenie",
                "VBL": "Velké balenie",
                "DBL": "Dodávateľské balenie"
            },
            "pdpProductDialog": {
                "title": "Informácie o produkte"
            },
            "payment": {
                "errorGeneral": "Nastala chyba pri spracovaní požiadavky",
                "error": "Platba skončila chybou",
                "pgnr": "Vaša platba nebola spracovaná z dôvodu nedostupnosti platobnej brány",
                "sapOrderNotFound": "Táto zákazka nemôže být zaplatená"
            },
            "invoiceType": {
                "REGULAR": "Faktúra",
                "DEPOSIT": "Zálohová faktúra",
                "CREDIT": "Dobropis",
                "CREDIT_PRICE": "Cenový dobropis",
                "DEBIT_PRICE": "Cenový vrubopis",
                "CREDIT_BONUS": "Dobropis za bonus",
                "CANCELLATION": "Storno faktúra",
                "DEPOSIT_CANCELLATION": "Storno zálohová faktúra",
                "CREDIT_CANCELLATION": "Storno dobropis"
            },
            "deliveryNoteType": {
                "REGULAR": "Štandardný dodací list",
                "RETURN": "Vratkový dodací list"
            },
            "orderConfirmation": {
                "thankYouMessage": "Ďakujeme za Vašu objednávku",
                "processingOrderMessage": "Vaša objednávka sa spracováva.",
                "confirmOrderMessage": " Obratom obdržíte potvrdenie s číslom zákazky.",
                "proformaMessage": "Zvolili ste si platbu: {{ paymentType }}. Proforma faktúru nájdete v detaile zákazky po jej potvrdení.",
                "pendingMessage": "Vaša platba sa spracováva.",
                "paidMessage": "Vaša objednávka bola úspešne zaplatená.",
                "cancelledMessage": " Vaša platba bola zrušená.",
                "emailMessage": "Kompletné informácie o objednávke budú odoslané na e-mail",
                "repeatPayment": "Opakovať platbu",
                "errorMessage": "Vaša platba skončila chybou.",
                "bonusProgramPoints": "{{count}} bonusových bodov je na ceste k Vám",
                "bonusProgramInfo": "Bonusové body sa pripíšu na Váš účet hneď po prevzatí tovaru. Za body je možné získať zľavu na vybraný sortiment."
            },
            "ticket": {
                "ticket": "Nezrovnalosť",
                "ticketHistoryPageTitle": "História nezrovnalostí",
                "allDetails": "Všetky detaily",
                "product": "Produkt",
                "addData": "Doplniť údaje",
                "order": "Zákazka",
                "creationDate": "Dátum nahlásenia",
                "deliveryDate": "Dátum odberu",
                "document": "Dodací list",
                "addedPhotos": "Priložené fotografie",
                "yourNote": "Váš popis",
                "comments": "Vyjadrenia",
                "sendTicket": "Posunúť na spracovanie",
                "notFound": "Nezrovnalosť sa nenašla",
                "creationError": "Nepodarilo sa založiť nezrovnalosť",
                "status": {
                    "label": "Stav",
                    "customeraction": "Akcia zákazníka",
                    "open": "Nové",
                    "inprocess": "Spracováva sa",
                    "conflict": "Spor",
                    "resolved": "Vybavené",
                    "rejected": "Zamietnuté"
                },
                "reason": {
                    "label": "Dôvod",
                    "complaint": "Sťažnosť/Reklamácia",
                    "discrepancy": "Nezrovnalosť",
                    "damaged": "Poškodené",
                    "incorrect_amount": "Nesprávne množstvo",
                    "not_delivered": "Nedodané",
                    "incorrect_product": "Zámena",
                    "incorrect_color_dimension": "Nesprávny odtieň/rozmer",
                    "other": "Iné"
                }
            },
            "facet": {
                "activeFilters_one": "{{count}} aktívny",
                "activeFilters_few": "{{count}} aktívne",
                "activeFilters_other": "{{count}} aktívnych",
                "shownProducts_one": "{{count}} zobrazený produkt",
                "shownProducts_few": "{{count}} zobrazené produkty",
                "shownProducts_other": "{{count}} zobrazených produktov",
                "label": "Filter",
                "notFound": "Hmm... Nič sa nenašlo.",
                "cancelFacets": "Zrušiť všetky filtre",
                "cancelFacetsShort": "Zrušiť všetky",
                "showMoreFacets": "Ďalších",
                "showResults": "Zobraziť výsledky",
                "updateFilters": " Upraviť filtre",
                "typeSearchString": "Zadajte hľadaný výraz",
                "activeList": "Aktívne filtre:"
            },
            "disponibility": {
                "inStock": "Na sklade {{amount}} {{unit}}",
                "upcoming": "Na ceste",
                "upcomingWithDelivery": "Čakáme {{date}}",
                "onOrder": "Na objednávku",
                "onOrderWithTime_one": "Bežná doba dodania {{count}} pracovný deň",
                "onOrderWithTime_few": "Bežná doba dodania {{count}} pracovné dni",
                "onOrderWithTime_other": "Bežná doba dodania {{count}} pracovných dní",
                "outOfStock": "Nie je na sklade"
            }
        }
    }
}
